module.exports = __webpack_public_path__ + "img/1-2.c4744a67.svg";